import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { ROUTE_UI_SECTION_NAME } from '../../../../constants/route'
import { useInitData, useLinkLikeClick } from '../../../../hooks'
import { getRequestProfilePathname } from '../../../../utils/link'
import Button, { BUTTON_HEIGHT_32 } from '../../../Button'
import { Rating, RATING_ITEM_SIZE } from '../../../Rating'
import Text from '../../../Text'

import { getRatingButtonQaName } from './ProfileFinishedWidgetRating.utils'

import * as styles from './ProfileFinishedWidgetRating.module.css'

import EditIcon from '../../../../icons/edit.svg'
import PlusIcon from '../../../../icons/plus.svg'

function ProfileFinishedWidgetRating({
  id: requestId,
  isInteractionDisabled,
  permissions,
  rating,
  onOpenRating,
}) {
  const { t } = useTranslation()

  const { handleClick } = useLinkLikeClick()

  const { availableSections } = useInitData()

  const isProfileAvailable =
    availableSections[ROUTE_UI_SECTION_NAME.serviceRequest]

  const feedbackUuid = rating?.feedbackUuid

  const hasRating = Boolean(rating?.value)

  const canEdit =
    !isInteractionDisabled &&
    (Boolean(feedbackUuid) ||
      permissions?.can_set_rating ||
      permissions?.can_add_feedback)

  function handleOpenFeedbackPage() {
    handleClick({
      link: getRequestProfilePathname({
        additionalParams: isProfileAvailable ? '/rating' : '/feedback/',
        availableSections,
        id: requestId,
      }),
      outsideLink: !isProfileAvailable,
    })
  }

  function handleOpenModal() {
    if (canEdit) {
      onOpenRating(feedbackUuid)
    } else {
      handleOpenFeedbackPage()
    }
  }

  return (
    <div className={styles.ProfileFinishedWidgetRating}>
      <Text isSecondary className={styles.label}>
        {t('Widget.RatingTitleKey')}
      </Text>
      <div className={styles.rating}>
        {hasRating ? (
          <Rating
            interactable={!isInteractionDisabled}
            itemSize={RATING_ITEM_SIZE.size24}
            rating={rating.value}
            onClickRow={isInteractionDisabled ? undefined : handleOpenModal}
          />
        ) : (
          <Text isSecondary>{t('Widget.RatingNoDataKey')}</Text>
        )}
        {canEdit ? (
          <Button.Outlined
            isGrey
            beforeIconProps={{ Icon: hasRating ? EditIcon : PlusIcon }}
            className={styles.editButton}
            height={BUTTON_HEIGHT_32}
            qaName={getRatingButtonQaName(hasRating)}
            tooltip={t(
              hasRating
                ? 'Widget.EditRatingTooltipKey'
                : 'Widget.AddRatingTooltipKey'
            )}
            tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
            onClick={handleOpenModal}
          />
        ) : null}
      </div>
    </div>
  )
}

export default ProfileFinishedWidgetRating
